
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";

  @Component({
    components: {
      ModalSectionsDivider,
    },
  })
  export default class ModalContent extends Vue {
        @Prop({ type: String, default: 'pt-5' }) readonly actionClasses?: string;

  }
